import { z } from 'zod'
import { Name } from '../../_kernel/Name'
import { Slug } from '../../_kernel/Slug'
import { PropertyFilter } from './PropertyFilter'

export const PAY_LATER = 'pay-later' as const
export const PAY_NOW_FULL = 'pay-now-full' as const
export const PAY_PARTIAL = 'pay-partial' as const

export const PAYMENT_OPTIONS = [PAY_LATER, PAY_NOW_FULL, PAY_PARTIAL] as const

export type PaymentOptionType = (typeof PAYMENT_OPTIONS)[number]

export const PaymentOptionValidation = z.object({
  name: z.instanceof(Name, { message: '[PaymentOption] name is required' }),
  slug: z.instanceof(Slug, { message: '[PaymentOption] slug is required' }),
})

export class PaymentOption extends PropertyFilter {
  static create({ name, slug }: z.infer<typeof PaymentOptionValidation>) {
    PaymentOptionValidation.parse({ name, slug })
    return new PaymentOption(name, slug)
  }
}
